<template>
<div class=''>
  <b-card>
    <div class=''>
      <b-row>
        <b-col md='3'>
        </b-col>
        <b-col>
          <b-row>
            <b-col md='2'>
              <img class='photo-customer' :src='user.img' alt=''>
            </b-col>
            <b-col md='10'>
              <h3>Cliente: {{user.name}}</h3>
              <h4>Saldo: {{format(saldoAux)}}</h4>
            </b-col>
          </b-row>
        </b-col>
        <b-col md='3'>
              <h5 style="color:green">Consumo actual: {{format(purchase)}}</h5>
              <h5 style="color:red">Bloqueo de consumo diario: {{format(lockSaldo)}}</h5>
        </b-col>
      </b-row>
      <b-row style='margin-top: 20px;'>
        <b-col md='3'>
          <b-row>
          <b-col md='12'>
        <h4 class='title-item bill'>Categorias</h4>
  <carousel :perPage='3' :paginationEnabled='false' >
    <slide class='category-item text-center' v-for='item in categories' :key='item.index' v-if='item.enable'>
      <div @click='toggleCategories(item)' class='text-center'>
           <b-img rounded='circle' v-bind:src='item.image ? item.img : imgCategory' v-bind:alt='item.name' style='height: 85px;'></b-img>
          <p>{{ item.name }}</p>
      </div>
    </slide>
  </carousel>
        </b-col>
          <b-col md='12'>
            <h4 class='title-item'>Sub categorias {{nameCategory}}</h4>
            <h4 class='text-center' v-show='subcategories.length==0'>Esta categoria no contiene Subcategorias</h4>
            <carousel :perPage='3' :paginationEnabled='false'>
            <slide class='category-item' :navigationEnabled='false' v-for='item in subcategories' :key='item.index'>
              <div @click='toggleSubCategories(item)' class='text-center'>
                <b-img rounded='circle' v-bind:src='item.image ? item.img : imgSubcategory' v-bind:alt='item.name' style='height: 85px;'></b-img>
              <p>{{ item.name }}</p>
              </div>
            </slide>
            </carousel>
          </b-col>
          </b-row>
        </b-col>
        <b-col md='6'>
          <b-row>
            <h4 class='title-item'>Productos</h4>
              <div class='cart cart-resume ' style='position:relative;height:350px;overflow-y:auto'>

            <h4 class='text-center' v-show='products.length==0'>No existen productos</h4>
                  <div v-for='item in products' :key='item.index'>
                    <div class='product' data-price='4.9' data-quantity='2' @click='add(item)'>
                      <div class='product-preview'>
                        <div class='thumbnail'>
                          <img class='image' v-bind:src='item.image ? item.img : imgProduct' v-bind:alt='item.name' style='height: 100px;' />
                        </div>
                        <div class='product-paper'>
                          <div class='product-name'>
                            <i v-if='item.enlistment' style='color:red' class="icon-star"></i>
                            {{ item.name.substring(0, 25) }}
                          </div>
                          <div class='product-price'>{{ format(item.price) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </b-row>
        </b-col>

        <b-col v-show='list.length>0'>
        <h4 class='title-item'>
            Resumen
          </h4>
          <div>
              <b-row style='position:relative;height:250px;overflow-y:auto'>
              <b-col  v-for='item in lista' :key='item.index' :md='12'>
                <b-row class='p-resume' align='center'>
                  <b-col md='2'>
                     <b-button size='lg' variant='primary' @click='minus(item)'> - </b-button>
                  </b-col>
                  <b-col md='8' align='center'>
                  <h5 class='text-center'> {{item.name}} x {{item.count}}</h5>
                  <p @dblclick='del(item)'>( {{ format(item.price) }} ) {{format(item.count * item.price)}}</p>
                  </b-col>
                  <b-col md='2'>
                    <b-button size='lg' variant='primary' @click='plus(item)'> +  </b-button>
                  </b-col>
                </b-row>
                </b-col>
              </b-row>
          </div>
          <div>
              <b-row>
                <b-form-textarea style='margin:10px' id='textarea1'
                     v-model='comments'
                     placeholder='Observaciones sobre pedido'
                     :rows='3'
                     :max-rows='6'>
                </b-form-textarea>
              </b-row>
          </div>
          <div>
            <b-row>
              <b-col>
                <div align='middle' style='
                      font-size: 1.4em;
                      background: #f1d5a5;
                      padding: 7px 2px;
                      border-radius:  2px;
                  '>
                  Total: {{total}}
                </div>
              </b-col>
              <b-col>
                <b-button size='lg' class='btn-block' variant='success' @click='buy'>Comprar</b-button>
              </b-col>
            </b-row>
          </div>
      </b-col>
      </b-row>
    </div>
  </b-card>
</div>
</template>
<script>
import {currencyFormat} from '@/api'
export default {
  name: 'Forms',
  data() {
    return {
      modalShow: false,
      list: [],
      products: [],
      subcategories: [],
      categories: [],
      changed: false,
      inmediate: false,
      enlistment: false,
      nameCategory: '',
      comments:'',
      nameSubCategory: '',
      lockSaldo: '',
      purchase: '',
      total: 0,
      imgCategory: 'static/img/category_icon.png',
      imgSubcategory: 'static/img/sub_category.png',
      imgProduct: 'https://s.cdpn.io/24822/sidebar-cupcake.png',
      user: Object,
      saldoAux: Number
    };
  },
  computed: {
    lista: {
      get: function() {
        return this.list;
      },
      set: function(newVal) {
        this.list = newVal;
        this.calculate();
      }
    }
  },
  watch: {
    categories: function(newVal) {
      console.log('asada');
    }
  },
  mounted() {
    this.getCategories();
    this.user = this.$store.getters.cafeteriaRequests.credential;
    this.user.img = this.setMainPathImage(this.user)
    this.saldoAux = this.user.saldo;
    this.lockSaldo = this.user.lockSaldo
    this.purchase = this.user.purchase
  },
  created() {
    // this.getCategories()
  },
  methods: {
    setMainPathImage(element){
      let mainPath = localStorage.getItem('urlApi')
      mainPath = mainPath.replace('/api', '')
      let img = mainPath + element.url
      return img
    },
    getCategories() {
      this.$store
        .dispatch('inventoryProductsCategoriesAll')
        .then(response => {
          this.categories = this.$store.getters.inventoryProductsCategories.items;
          this.categories.forEach(element => {
            let mainPath = localStorage.getItem('urlApi');
            mainPath = mainPath.replace('/api', '');
            element.img = mainPath + element.url;
          });
        })
        .catch(error => {
          console.log('ERROR ', error);
        });
    },
    toggleCategories: function(item) {
      this.nameCategory = 'de ' + item.name;
      let data = {
        id: item.id,
        id_user: this.user.id_user_primary
      }
      this.$store
        .dispatch('inventoryProductsSubcategoriesAll', data)
        .then(response => {
          this.subcategories = this.$store.getters.inventoryProductsSubCategories;
          this.subcategories.forEach(element => {
            let mainPath = localStorage.getItem('urlApi');
            mainPath = mainPath.replace('/api', '');
            element.img = mainPath + element.url;
          });
          this.products = [];
        })
        .catch(error => {
          console.log('ERROR ', error);
        });
    },
    toggleSubCategories: function(item) {
      let data = {
        id: item.id,
        id_user: this.user.id_user_primary
      }
      this.$store
        .dispatch('inventoryProductsFilterSubCategoriesAll', data)
        .then(response => {
          this.products = this.$store.getters.inventoryProductsSubCategories;
          this.products.forEach(element => {
            let mainPath = localStorage.getItem('urlApi');
            mainPath = mainPath.replace('/api', '');
            element.img = mainPath + element.url;
          });
        })
        .catch(error => {
          console.log('ERROR ', error);
        });
    },
    updateProduct: function(product) {},
    updateBill() {},
    plus(item) {
      this.list.forEach(element => {
        if (element.id === item.id) {
          if (item.stock >= element.count + 1) {
            element.count++;
          } else {
            alert('No hay suficientes productos');
          }
        }
      });
      this.lista = this.list;
    },
    minus(item) {
      this.list.forEach(element => {
        if (element.id === item.id) {
          element.count--;
          if (element.count < 1) {
            this.list.splice(this.list.indexOf(element), 1);
          }
        }
      });
      this.lista = this.list;
    },
    add(item) {
      this.changed = false;
      this.list.forEach(element => {
        if (element.id === item.id) {
          if (item.stock >= element.count + 1) {
            element.count++;
            this.changed = true;
          } else {
            alert('No hay suficientes productos');
            this.changed = true;
          }
        }
      });
      if (!this.changed) {
        item.count = 1;
        this.list.push(item);
      }
      this.lista = this.list;
    },
    del(item) {
      this.list.splice(this.list.indexOf(item), 1);
      this.lista = this.list;
    },
    buy() {
      if (this.list.length === 0) {
        alert('Debe agregar por lo menos un producto al pedido');
        return;
      }
      if(this.lockSaldo>0){
        if(this.lockSaldo < (this.purchase + (this.total))){
          this.$root.showInfoDialog('Mensaje informativo','La compra excede el bloquedo diario de consumo','Aceptar')
          return
        }
      }
      let data = {
        enlistment: this.enlistment,
        inmediate: this.inmediate,
        products: this.list,
        id_user: this.user.id_user_primary,
        total: this.total,
        comment: this.comments,
        date_program: this.comments
      };
      let json = JSON.stringify(data);
      this.$store
        .dispatch('cafeteriaRequestsCreate', json)
        .then(response => {
          this.products = this.$store.getters.inventoryProductsSubCategories;
        })
        .catch(error => {
          console.log('ERROR ', error);
        });
      // cafeteriaRequestsCreate
    },
    calculate() {
      this.enlistment = false
      this.total = 0;
      //this.saldoAux = JSON.parse(JSON.stringify(this.user.saldo));
      if(!this.list.length){
        this.saldoAux = this.user.saldo
      }
      this.list.forEach(element => {
        if(element.enlistment){
          this.enlistment = true
        }
        this.saldoAux = this.user.saldo
        this.total += element.count * element.price;
        this.saldoAux -= this.total;

        if (this.saldoAux < 0) {
          this.$root.showInfoDialog('Mensaje informativo','El usuario no posee fondos suficientes','Aceptar');
          this.list.splice(this.list.indexOf(element));
          this.calculate();
        }
      });
      this.total = this.total;
    },
    format(value) {
      return currencyFormat(value)
    }
  }
};
</script>
<style>
.p-resume {
  margin: 7px 0;
  padding: 5px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/cafeteria/requests/alternative1.vue